export const MOCKDATA = {
    "name": "",
    "version": "1.0.0",
    "description": "",
    "updateTime": "2023-05-01 10:35:00",
    "data": [
        {   
            "id": 1,
            "os": "Windows",
            "name": "Windows",
            "icon": "win",
            "tip": "兼容 Windows7 及以上",
            "hasQrCode":false,
            "url":"https://instant-share.oss-cn-shenzhen.aliyuncs.com/software/1-1761708602490_QuickShare_2.5.4.7.zip"
        },
        { 
            "id": 2,
            "os": "macOS",
            "name": "macOS",
            "icon": "macOS",
            "tip": "兼容 OSX10.10 及以上",
            "hasQrCode":false,
            "url":"https://instant-share.oss-cn-shenzhen.aliyuncs.com/software/1-1761906086397_MacQuickShareClient.zip"
        },
        { 
            "id": 3,
            "os": "Android",
            "name": "Android",
            "icon": "android",
            "tip": "兼容 Android5.1 及以上",
            "hasQrCode":true,
            "url":"https://instant-share.oss-cn-shenzhen.aliyuncs.com/software/1-1754388225914_QuickShare-release-2.2.134%2822192%29.apk"
        },
        { 
            "id": 4,
            "os": "iOS",
            "name": "iOS、ipadOS",
            "icon": "ios",
            "tip": "兼容 iOS9 及以上",
            "hasQrCode":true,
            "url":"https://itunes.apple.com/cn/app/id1482399002?mt=8"
        },
        { 
            "id": 5,
            "os": "Linux",
            "name": "Linux",
            "icon": "linux",
            "tip": "兼容 Ubuntun 64 16.0 及以上",
            "hasQrCode":false,
            "url":"https://instant-share.oss-cn-shenzhen.aliyuncs.com/software/1-1722395125665_QuickShareLinuxClient0.3.8.zip"
        }
    ]
}